/* global $ */

export default {
  name: "SidebarContext",

  props: {
    main_label: {
      type: String,
      required: true
    },
    sub_label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "bi bi-buildings"
    },
    items: {
      type: Array,
      required: true
    },
    active_id: {
      type: [String, Number],
      default: null
    },
    open: {
      type: Boolean,
      default: false
    },
    top_label: {
      type: String,
      default: ""
    },
    top_subtitle: {
      type: String,
      default: ""
    },
    top_active: {
      type: Boolean,
      default: false
    },
    sectors: {
      type: Array,
      default: () => []
    },
    active_sector: {
      type: String,
      default: null
    }
  },

  emits: ["toggle", "select", "select-top", "select-sector"],

  data() {
    return ({
      search: "",
      search_threshold: 5,
      view: "sectors"
    });
  },

  computed: {
    current_sector() {
      return this.sectors.find((sector) => sector.id === this.active_sector) || null;
    },

    filteredItems() {
      const term = this.search.toLowerCase();
      if (!term) return this.items;

      return this.items.filter((item) => {
        return `${item.label || ""} ${item.description || ""}`.toLowerCase().includes(term);
      });
    }
  },

  watch: {
    open(is_open) {
      if (!is_open) {
        this.search = "";
        return;
      }

      // Always open on the sector list when sectors are provided
      this.view = this.sectors.length ? "sectors" : "items";
    },

    view(current_view) {
      if (current_view === "items") {
        this.$nextTick(() => this.$refs.search_input?.focus());
      }
    }
  },

  mounted() {
    this.bindOutsideClick();
  },

  beforeUnmount() {
    $(document).off("click.sidebar-context", this.outside_click_handler);
  },

  methods: {
    isLive(item) {
      if (typeof item.is_live === "boolean") return item.is_live;
      return String(item.id).includes("(Live)");
    },

    isActive(item) {
      return item.id === this.active_id;
    },

    isActiveSector(sector) {
      return sector.id === this.active_sector;
    },

    selectSector(sector) {
      if (!sector.available) return;

      // Current sector drills into its item list; others are handled by the parent
      if (this.isActiveSector(sector)) {
        if (this.items.length) {
          this.view = "items";
        } else {
          this.toggle();
        }
        return;
      }

      this.$emit("select-sector", sector);
    },

    toggle() {
      this.$emit("toggle");
    },

    select(item) {
      // Re-selecting the current property only closes the dropdown
      if (this.isActive(item)) {
        this.toggle();
        return;
      }

      this.$emit("select", item);
    },

    selectTop() {
      if (this.top_active) {
        this.toggle();
        return;
      }

      this.$emit("select-top");
    },

    bindOutsideClick() {
      this.outside_click_handler = (e) => {
        // Ignore targets removed by a re-render (e.g. switching between sector levels)
        if (!this.open || !e.target.isConnected) return;

        if (!this.$el.contains(e.target)) {
          this.$emit("toggle");
        }
      };

      $(document).on("click.sidebar-context", this.outside_click_handler);
    }
  }
};
